import { useTranslation } from 'react-i18next'

import { CertificateModal } from 'entities/sales/components/certificate-modal'

import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { Switch } from 'shared/ui/switch'

import s from './styles.module.scss'

interface Props {
  isActive?: boolean
  setIsActive?: (value: boolean) => void
}

export const CertificateUse = ({ isActive, setIsActive }: Props) => {
  const { t } = useTranslation()
  const { openDialog } = useDialogBottomSheet()

  const handleChange = (value: boolean) => {
    setIsActive?.(value)
  }

  const onShowDetailInfo = () => {
    openDialog({
      padding: [0],
      isDialog: false,
      isClickable: false,
      child: <CertificateModal />,
    })
  }

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={s.title}>
          {`${t('certificate.you_won', { sum: '10 000' })} ${String.fromCharCode(8384)}`}
        </p>

        <span
          className={s.subtitle}
          onClick={onShowDetailInfo}
        >
          {t('certificate.conditions')}
        </span>
      </div>

      <Switch
        isChecked={Boolean(isActive)}
        onChange={handleChange}
      />
    </div>
  )
}
